import styled from 'styled-components'

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 42px;
  width: 42px;
  background-color: #66bb6a;
  color: #fff;
  border-radius: 100%;
`

export const ErrorContainer = styled(SuccessContainer)`
  background-color: #f44336;
`
